module.exports = __webpack_public_path__ + "static/media/llanta-inspeccion-black.ffc0a67a.svg";